import { render, staticRenderFns } from "./CommonTitle.vue?vue&type=template&id=620bcfda&scoped=true"
import script from "./CommonTitle.vue?vue&type=script&lang=js"
export * from "./CommonTitle.vue?vue&type=script&lang=js"
import style0 from "./CommonTitle.vue?vue&type=style&index=0&id=620bcfda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620bcfda",
  null
  
)

export default component.exports